import type { LiveKitTokenResponse } from "./hedra-avatar-manager";

/**
 * API client for the Hedra Avatar Widget
 *
 * In the new architecture, this client only handles:
 * - Getting LiveKit tokens for room connection
 *
 * The Python agent handles STT, LLM, and TTS directly.
 */
export class WidgetApiClient {
  private baseUrl: string;
  private widgetId: string;

  constructor(baseUrl: string, widgetId: string) {
    this.baseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
    this.widgetId = widgetId;
  }

  /**
   * Generate LiveKit token for Hedra avatar
   * The widgetId is passed so the agent can fetch widget config and RAG
   */
  async getLiveKitToken(
    avatarId: string,
    voiceId: string
  ): Promise<LiveKitTokenResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/api/livekit/token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          roomName: `avatar-${Date.now()}`,
          participantName: `user-${Date.now()}`,
          avatarId,
          voiceId,
          widgetId: this.widgetId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Token generation failed: ${response.statusText}`);
      }

      const data = (await response.json()) as LiveKitTokenResponse;
      return data;
    } catch (error) {
      console.error("API: LiveKit token generation error:", error);
      throw error;
    }
  }
}
